<!--
  @Description 流程下发主界面
  @Date 2022-02-22
  @Author liushuo
-->
<template>
  <div class="container">
    <homeHeader title="流程下发"></homeHeader>
    <div class="main" v-show="isSearch">
      <div class="card">
        <div class="toolbar-dv">
          <toolBarBtn
            :parentData="this"
            :buttonVisible="buttonVisible"
            :moreButtonList="moreButtonList"
            ref="toolBarBtn"
          ></toolBarBtn>
        </div>
        <div class="table-dv">
          <vxe-grid
            border
            resizable
            size="mini"
            :column-config="{ minWidth: '80px' }"
            :cell-style="cellStyle"
            :columns="tableColumns"
            :height="tableHeight"
            ref="xTable"
            :mouse-config="{ area: true, extension: true }"
            highlight-hover-row
            highlight-current-row
            :keyboard-config="{
              isArrow: true,
              isEnter: true,
              isTab: true,
              enterToTab: true,
              isClip: true
            }"
            :seq-config="{
              startIndex: (tablePage.currentPage - 1) * tablePage.pageSize
            }"
            :pager-config="tablePage"
            :data="tableData"
            @page-change="handlePageChange"
            @cell-dblclick="handleDbClick"
          ></vxe-grid>
        </div>
      </div>
    </div>
    <!-- 明细界面 -->
    <YKIssuedFlowDetail :parentData="this" :joinID="joinID" @SingleBack="SingleBack" v-if="!isSearch" />
  </div>
</template>

<script>
import YKIssuedFlowDetail from './YKIssuedFlowDetail.vue'
import { TEXT_COLOR_MAP } from '@/public/params/global.js'

export default {
  components: {
    YKIssuedFlowDetail
  },
  created() {
    this.InitColumn()
  },
  mounted() {
    // this.BindData()
  },
  activated() {
    this.getRouteParams()
    this.BindData()
  },
  data() {
    return {
      // 分页设置
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 200,
        align: 'right',
        pageSizes: [200, 300, 400, 500],
        layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
        perfect: true
      },
      tableData: [],
      // 列设置
      tableColumns: [],
      buttonVisible: {
        add: false, // 新增按钮
        lock: false, // 锁定按钮是否显示
        save: false, // 锁定按钮是否显示
        unlock: false, // 解锁按钮是否显示
        update: false,
        delete: false,
        sort: false, // 排序按钮是否显示
        search: false, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      // 拓展按钮
      moreButtonList: [],
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 是否为search界面
      isSearch: true,
      // 传给子组件的id（当前点击的行id）
      joinID: 0,
      // 当前表格滚动条位置
      curScrollTop: 0
    }
  },
  methods: {
    // 获取数据
    async BindData() {
      if (!this.Authority.see) {
        this.$message.error('您没有查看权限！')
        return
      }
      this.tableData = []
      const { data: res } = await this.$http.post('/Common/YKIssuedFlow/list', {
        pageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
        seeType: this.Authority.seeType
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.tableData = res.data.rows
      this.tablePage.total = res.data.totals
    },
    // 刷新数据
    refresh() {
      this.BindData()
    },
    // 初始化
    InitColumn() {
      this.tableColumns = [
        {
          type: 'seq',
          width: 50
        },
        {
          field: 'num',
          title: '编号',
          width: 100,
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'menuArgs',
          title: '产品类型',
          width: 200,
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'subject',
          title: '主题',
          width: 200
        },
        {
          field: 'issuedVersion',
          title: '实际更新版本',
          width: 200,
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'issuedType',
          title: '下发类型',
          width: 200,
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'requestIssuedDate',
          title: '要求下发日期',
          width: 200,
          formatter: ['formatDate', 'yyyy-MM-dd'],
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          field: 'issuedDate',
          title: '实际下发日期',
          width: 200,
          formatter: ['formatDate', 'yyyy-MM-dd'],
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          field: 'companyName',
          title: '下发企业名称',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        }
      ]
    },
    add() {
      if (!this.Authority.edit) {
        this.$message.error('您没有相关权限！')
        return
      }
      this.joinID = 0
      this.$nextTick(() => {
        this.isSearch = false
      })
    },
    // 页面函数
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      this.BindData()
    },
    // 双击查看明细数据
    handleDbClick({ row }) {
      this.toSingle(row.id)
    },
    // 跳转到single界面
    toSingle(id) {
      this.$refs.xTable.closeTooltip()
      // 记录当前点击浏览的滚动条位置
      this.curScrollTop = this.$refs.xTable.getScroll()?.scrollTop

      this.joinID = id

      this.$nextTick(() => {
        this.isSearch = false
      })
    },
    /**
     * 从single返回到search
     * （暂时弃用该参数）@param {Number} id 返回前的single单据标识
     */
    async SingleBack() {
      this.isSearch = true
      await this.BindData()

      setTimeout(() => {
        // 跳转到上一次浏览的地方
        this.$refs.xTable.scrollTo(0, this.curScrollTop)

        // 设置上一次点击行为高亮状态
        const LAST_TIME_CLICK_ROW = this.$refs.xTable.getTableData().fullData.find(row => row.id === this.joinID)
        this.$refs.xTable.setCurrentRow(LAST_TIME_CLICK_ROW)
      }, 0)
    },
    getRouteParams() {
      // 若是带着明细id打开的search界面，则直接跳转到single界面
      if (this.$route.params?.id > 0) {
        this.toSingle(this.$route.params.id)
      }
    },
    cellStyle({ column, row }) {
      // 实际下发日期在要求下发日期内：绿色；超期则红色；无实际下发日期则黑色
      if (column.property === 'issuedDate') {
        return this.setCellColor(row)
      }
    },
    setCellColor(row) {
      // 无实际下发日期：正常色
      if (row['issuedDate'] === '' || row['issuedDate'] == null) {
        return
      }

      const IS_OUTDATE = this.isDateInRange(row['requestIssuedDate'], row['issuedDate'])
      // 实际下发日期 > 要求下发日期：红色
      if (!IS_OUTDATE) {
        return {
          color: TEXT_COLOR_MAP['RED']
        }
      } else {
        // 实际下发日期 < 要求下发日期：绿色
        return {
          color: TEXT_COLOR_MAP['GREEN']
        }
      }
    },
    /**
     * 当前日期是否在目标日期范围内（当前日期 <= 目标日期）
     * @param targetDate {String} 目标日期
     * @param curDate {String} 当前日期
     */
    isDateInRange(targetDate, curDate) {
      const OUT_DATE = false
      const IN_DATE = true

      if (targetDate == null || targetDate === '') {
        return OUT_DATE
      }
      if (curDate == null || curDate == '') {
        return IN_DATE
      }
      let td = new Date(targetDate).getTime()
      let cd = new Date(curDate).getTime()
      // 24-04-23 刘福 修改为超过一天才超期
      if (cd <= td + 24 * 60 * 60 * 1000) {
        return IN_DATE
      }
      return OUT_DATE
    }
  },
  computed: {
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      // 若有查询框，则共有四段 margin 否则只有表格的两段 margin
      let topBottomMargin = 20
      let tableMargin = isSearchForm
        ? this.heightConfig.mainMargin * 4
        : this.heightConfig.mainMargin * 2 + topBottomMargin
      let isToolBar = true
      return this.tableHeightComputed(tableMargin, isSearchForm, isToolBar)
    }
  }
}
</script>

<style lang="less" scoped>
@main-margin: 15px;
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

.vxe-checkbox {
  width: 15px !important;
}
</style>
